<ul class="app-menu" [class.compacted]="menuCompacted">
	<ng-container *ngFor="let item of visibleItems; let i = index">
		<li *ngIf="!item.children?.length" class="app-menu-item">
			<a
				[routerLink]="item.link"
				routerLinkActive="active"
				[attr.title]="itemTooltip(item.title)"
				(click)="onNavigate(item)"
			>
				<i *ngIf="menuIconClass(item.icon) as icon" [class]="icon" aria-hidden="true"></i>
				<span class="app-menu-label">{{ item.title }}</span>
			</a>
		</li>

		<li
			*ngIf="item.children?.length"
			class="app-menu-group"
			[class.expanded]="isGroupExpanded(i)"
			[class.has-active-child]="isGroupActive(i)"
			[class.flyout-open]="isFlyoutOpen(i)"
		>
			<button
				type="button"
				class="app-menu-group-title"
				[attr.title]="itemTooltip(item.title)"
				[attr.aria-expanded]="menuCompacted ? isFlyoutOpen(i) : isGroupExpanded(i)"
				(click)="toggleGroup(i, $event)"
			>
				<i *ngIf="menuIconClass(item.icon) as icon" [class]="icon" aria-hidden="true"></i>
				<span class="app-menu-label">{{ item.title }}</span>
				<i class="pi pi-chevron-down app-menu-chevron" aria-hidden="true"></i>
			</button>
			<ul *ngIf="isGroupExpanded(i) && !menuCompacted" class="app-menu-group-items">
				<li *ngFor="let child of item.children" class="app-menu-item app-menu-subitem">
					<a
						[routerLink]="child.link"
						[class.active]="isChildLinkActive(child, item.children || [])"
						(click)="onNavigate(child)"
					>
						<span class="app-menu-label">{{ child.title }}</span>
					</a>
				</li>
			</ul>
		</li>
	</ng-container>
</ul>

<div
	#flyout
	*ngIf="menuCompacted && floatingGroupIndex !== null && floatingGroup as group"
	class="app-menu-flyout"
	[style.top.px]="flyoutTop"
	[style.left.px]="flyoutLeft"
	role="menu"
	[attr.aria-label]="group.title"
>
	<div class="app-menu-flyout-title">{{ group.title }}</div>
	<ul class="app-menu-flyout-items">
		<li *ngFor="let child of group.children" class="app-menu-item app-menu-subitem">
			<a
				[routerLink]="child.link"
				[class.active]="isChildLinkActive(child, group.children || [])"
				role="menuitem"
				(click)="onFlyoutNavigate(child)"
			>
				<span class="app-menu-label">{{ child.title }}</span>
			</a>
		</li>
	</ul>
</div>
